import React from 'react';
import { useTranslation } from 'react-i18next';
import { Elements, useStripe } from '@stripe/react-stripe-js';
import { PrimaryButton } from 'Core/components/Button';
import { AlertError } from 'Core/components/Alert';
import useHandleNextAction from 'Core/hooks/queries/stripe/useHandleNextAction';
import { stripeFor } from 'Core/utils/stripe';
import { messageOf } from 'Modules/checkout/api';

function AuthenticateButton({ clientSecret, onDone }) {
  const { t } = useTranslation();
  const stripe = useStripe();
  const authenticate = useHandleNextAction();

  const submit = () => authenticate.mutate({ stripe, clientSecret }, { onSuccess: onDone });

  return (
    <>
      {authenticate.isError && (
        <div className="mt-3" data-testid="stripe-error">
          <AlertError>{messageOf(authenticate.error)}</AlertError>
        </div>
      )}
      <div className="flex justify-end mt-2">
        <PrimaryButton
          type="button"
          data-testid="authenticate-payment"
          disabled={!stripe || authenticate.isLoading}
          onClick={submit}
        >
          {t('checkout.authenticatePayment.submit', 'Zahlung bestätigen')}
        </PrimaryButton>
      </div>
    </>
  );
}

export default function AuthenticatePayment({ clientSecret, publishableKey, onDone }) {
  return (
    <Elements stripe={stripeFor(publishableKey)} options={{ locale: 'de' }}>
      <AuthenticateButton clientSecret={clientSecret} onDone={onDone} />
    </Elements>
  );
}
